import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Index from './pages/Index';
import { ExpertisesPage } from './pages/Expertises';
import ExpertiseDetail from './pages/ExpertiseDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import WerkplaatsPage from './pages/Werkplaats';
import ContactPage from './pages/Contact';
import WhatsAppButton from './components/WhatsAppButton';
import { ThemeProvider } from './components/ThemeProvider';
import { Toaster } from './components/ui/toaster';
import AddVehicle from './pages/AddVehicle';
import ManageVehicles from './pages/ManageVehicles';
import VehicleDetailsPage from './pages/VehicleDetailsPage';
import MaintenanceHistoryPage from './pages/MaintenanceHistoryPage';
import MaintenanceOverviewPage from './pages/MaintenanceOverviewPage';
import NotFound from './pages/NotFound';
import OnzeCollectiePage from './pages/OnzeCollectie';

import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import AdminDashboard from "./pages/Admin";
import AdminSettings from "@/pages/admin/Settings";
import TeamManagement from "@/pages/admin/TeamManagement";
import ProtectedAdminRoute from '@/components/ProtectedAdminRoute';
import CmsDashboard from '@/pages/admin/CmsDashboard';
import CmsPageEditor from '@/pages/admin/CmsPageEditor';
import CmsMediaLibrary from '@/pages/admin/CmsMediaLibrary';
import CmsNavigationEditor from '@/pages/admin/CmsNavigationEditor';
import CmsExpertiseEditor from '@/pages/admin/CmsExpertiseEditor';
import CmsSiteSettings from '@/pages/admin/CmsSiteSettings';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 300000, // 5 minuten
    },
  },
});

// ScrollToTop component die de pagina naar boven scrollt bij routewijzigingen
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/expertises" element={<ExpertisesPage />} />
            <Route path="/expertises/:id" element={<ExpertiseDetail />} />
            <Route path="/onze-collectie" element={<OnzeCollectiePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/werkplaats" element={<WerkplaatsPage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* App routes */}
            <Route path="/app" element={<Dashboard />} />
            <Route path="/app/add-vehicle" element={<AddVehicle />} />
            <Route path="/app/manage-vehicles" element={<ManageVehicles />} />
            <Route path="/app/vehicles/:id" element={<VehicleDetailsPage />} />
            <Route path="/app/vehicles/:id/maintenance-history" element={<MaintenanceHistoryPage />} />
            <Route path="/app/vehicles/:id/maintenance-overview" element={<MaintenanceOverviewPage />} />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/team" element={<TeamManagement />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/cms" element={<ProtectedAdminRoute><CmsDashboard /></ProtectedAdminRoute>} />
            <Route path="/admin/cms/media" element={<ProtectedAdminRoute><CmsMediaLibrary /></ProtectedAdminRoute>} />
            <Route path="/admin/cms/navigation" element={<ProtectedAdminRoute><CmsNavigationEditor /></ProtectedAdminRoute>} />
            <Route path="/admin/cms/expertises" element={<ProtectedAdminRoute><CmsExpertiseEditor /></ProtectedAdminRoute>} />
            <Route path="/admin/cms/settings" element={<ProtectedAdminRoute><CmsSiteSettings /></ProtectedAdminRoute>} />
            <Route path="/admin/cms/:pageSlug" element={<ProtectedAdminRoute><CmsPageEditor /></ProtectedAdminRoute>} />

            <Route path="*" element={<NotFound />} />
          </Routes>
          <WhatsAppButton />
          <Toaster />
        </Router>
      </ThemeProvider>
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

export default App;
